'use client';
import SafeLink from '@/components/SafeLink';
import CDNImage from '@/components/cdnImage/cdnImage';
import style from '../style.module.scss';

// ---------------引入埋点------------------
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';

export default function Category(props: any) {
  const { category, index, floorIndex } = props;
  return (
    <SafeLink
      href={`/s?k=${encodeURIComponent(category?.cateName)}&l3=${encodeURIComponent(
        category?.cateId,
      )}`}
      key={index}
    >
      <div
        className={style.item}
        key={index}
        onClick={(e) =>
          spmTrackingUtils.spmClick({
            spm: `a0145.b002218.c00002482.${index + 1}`,
            page_id: 'Home_Main',
            event_id: 'Home_Popular_Categories',
            json_param: JSON.stringify({
              index: index,
              firstcid: '-100',
              secondcid: '-100',
              thirdcid: '-100',
            }),
            target: e.target as HTMLElement,
          })
        }
        data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
        data-exp={JSON.stringify({
          spm: `a0145.b002218.c00002482.${index + 1}`,
          page_id: 'Home_Main',
          event_id: 'Home_Popular_Categories_Expo',
          json_param: JSON.stringify({
            index: index,
            firstcid: '-100',
            secondcid: '-100',
            thirdcid: '-100',
          }),
        })}
      >
        <div className={style.bg} style={{ backgroundColor: category?.backgroundColor }}>
          <CDNImage
            src={category?.cateImageUrl}
            width={100}
            height={100}
            alt={`${category?.cateName} in popular categories`}
            priority={floorIndex < 6 && index < 4}
          />
        </div>
        <p>{category?.cateName}</p>
      </div>
    </SafeLink>
  );
}
